import { Injectable, inject } from "@angular/core";
import { ImportDataUrlsDto } from "@dtos/import-data.dto";
import { ApiService } from "@services/api.service";
import { EndPoints } from "@services/EndPoints";


@Injectable({ providedIn: 'root' })
export class ImportFileProvider {

    private readonly api = inject(ApiService);
    async GetImportDataUrls(): Promise<ImportDataUrlsDto | null> {
        try {
            return (await this.api.get<ImportDataUrlsDto>({ url: EndPoints.getImportDataUrls }));
        } catch (error) {
            //console.error('Error al obtener admins:', error);
            return null;
        }
    }
     async UploadBillingAccounts(file: File, clientId: number): Promise<{created: boolean, errors_count: number, errors: any}> {
        try {
            return (await this.api.post<{created: boolean, errors_count: number, errors: any}>({ url: EndPoints.importBillingAccountsExcel.replace("{clientId}", clientId.toString()), fileParams: { file: file } }));
        } catch (error) {
            //console.error('Error al obtener admins:', error);
            throw error;
        }
    }
    async UploadClients(file: File): Promise<{created: boolean, errors_count: number, errors: any}> {
        try {
            return (await this.api.post<{created: boolean, errors_count: number, errors: any}>({ url: EndPoints.importClientsExcel, fileParams: { file: file } }));
        } catch (error) {
            //console.error('Error al obtener admins:', error);
            throw error;
        }
    }
}
